import PropTypes from "prop-types";

export const ProductInfo = {
  brand: PropTypes.string.isRequired,
  productId: PropTypes.number.isRequired,
  productName: PropTypes.string.isRequired,
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  status: PropTypes.string.isRequired,
  website: PropTypes.string,
};

export const ActionRequestDetails = {
  productName: PropTypes.string,
  draftProductId: PropTypes.number,
  originalProductId: PropTypes.number,
  siteId: PropTypes.number,
  requestDate: PropTypes.string,
  requestName: PropTypes.string,
  expectedGoLiveDate: PropTypes.string,
  status: PropTypes.number,
  comments: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  previews: PropTypes.arrayOf(
    PropTypes.shape({
      siteId: PropTypes.number,
      previewUrl: PropTypes.string,
      siteType: PropTypes.string,
      siteName: PropTypes.string,
    })
  ),
};

export const ActionRequest = {
  productName: PropTypes.string.isRequired,
  draftProductId: PropTypes.number.isRequired,
  originalProductId: PropTypes.number,
  siteId: PropTypes.number,
  requestDate: PropTypes.string.isRequired,
  requestName: PropTypes.string.isRequired,
  expectedGoLiveDate: PropTypes.string.isRequired,
  status: PropTypes.number,
  comments: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  siteName: PropTypes.string.isRequired,
  lastModifiedOn: PropTypes.string,
  lastModifiedBy: PropTypes.string,
};
